<app-table [columns]="columns" [createLabel]="'JOB_CONTROLLING.ADD'" [editable]="true"></app-table>
